import { useEffect, useState } from "react"

import { FieldFilterType } from "../../../../base/types"
import { useAuth } from "../../../../../modules/auth"
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi"

interface IGatePassHistory {
    name?: string,
    createdOn?: Date
}

export const useGetGatePassHistory = (gatePassId?: string) => {
    const { user, siteId } = useAuth()
    const [getRecords] = useLazyReadMultipleQuery()
    const [records, setRecords] = useState<IGatePassHistory[]>([])
    const [intervalCount, setIntervalCount] = useState(0);

    useEffect(() => {
        if (!gatePassId)
            return;

        const interval = setInterval(() => {
            if (intervalCount < 5) {
                getHistory(gatePassId);
                setIntervalCount(prevCount => prevCount + 1);
            } else {
                clearInterval(interval);
            }
        }, 2000);

        return () => clearInterval(interval);

        // eslint-disable-next-line
    }, [user, gatePassId, intervalCount])

    const getHistory = (gatePassId: string): Promise<IGatePassHistory[]> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.')
        }

        return getRecords({
            userId: user?.userId || '',
            portalId: siteId || '',
            tableId: "edtec365_auditing",
            fieldList: ["edtec365_name", "edtec365_operationtime"],
            filters: [{
                group: 0, filters: [
                    { field: "edtec365_gatepass", type: FieldFilterType.Const, value: gatePassId },
                    { field: "statecode", type: FieldFilterType.Const, value: '0' }]
            }]
        })
            .unwrap()
            .then((data) => {
                const records = data.records.map<IGatePassHistory>(p => ({
                    name: p["edtec365_name"],
                    createdOn: p["edtec365_operationtime"]
                }))

                setRecords(records)
                return Promise.resolve(records);
            })
    }

    return { data: records }
}